export default __webpack_public_path__ + "static/media/vgl-blank-image.fc27d8fb.png";